<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">

 <script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://innovationplaza.it/cerca-bando/#webpage",
      "url": "https://innovationplaza.it/cerca-bando/",
      "name": "Bandi e Opportunita' di Finanziamento — Innovation Plaza",
      "description": "Bandi, call e programmi di finanziamento europei, nazionali e regionali per imprese, startup e istituzioni. Horizon Europe, FESR, FSE, MISE, PAC e programmi operativi regionali.",
      "inLanguage": "it-IT",
      "isPartOf": {
        "@id": "https://innovationplaza.it/#website"
      },
      "about": {
        "@type": "Thing",
        "name": "Finanziamenti e Bandi pubblici per l'innovazione"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://innovationplaza.it/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Bandi",
            "item": "https://innovationplaza.it/bandi/"
          }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Programmi di Finanziamento gestiti da Innovation Plaza",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Horizon Europe"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Digital Europe Programme"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Cooperazione Territoriale Europea (CTE)"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "Creative Europe"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "Bandi MISE per R&S"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "Programmi Operativi Regionali FESR-FSE-FC"
          },
          {
            "@type": "ListItem",
            "position": 7,
            "name": "Politica Agricola Comune (PAC)"
          }
        ]
      }
    },
    {
      "@type": "Service",
      "@id": "https://innovationplaza.it/cerca-bando/#service",
      "name": "Consulenza Strategica e Direzionale per l'Innovazione",
      "serviceType": "Consulenza di direzione e strategia",
      "description": "Supporto a imprese e istituzioni nei processi di analisi, strategia, marketing e ideazione. Gestione di iniziative complesse di sviluppo locale, territoriale e internazionale.",
      "url": "https://innovationplaza.it/cerca-bando/",
      "provider": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Italia"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Imprese, istituzioni, aspiranti imprenditori"
      }
    }
  ]
}
</script>
  
  <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
    style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

  <h1 class="text-222222 text-center text-font32px font-bold font-sans mt-10 mb-8">
    Bandi Green e Transizione Ecologica: Fondi per Imprese e Pubblica Amministrazione 2025-2027
  </h1>

  <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">

    <h2 class="font-medium text-font24px text-[#364349] mt-2 text-justify">
      Agevolazioni green per PMI: bandi su energie rinnovabili, efficienza energetica e circolarità. Incentivi
      PNRR Transizione 5.0 e programma LIFE
    </h2>

    <div (click)="goTo('cerca-bando')"
      class="mt-8 mb-8 text-white cursor-pointer bg-quintary ml-auto w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
      Ricerca bandi
    </div>

    <div class="transizione-verde">

      <div class="text-[#364349] text-font24px text-justify">
        Il panorama degli incentivi pubblici per imprese, startup e Pubblica Amministrazione è ampio,
        stratificato e in continua evoluzione. Comprendere quali risorse sono disponibili, per chi, con quali
        scadenze è la premessa di qualsiasi strategia di accesso alla finanza agevolata. Innovation Plaza
        organizza questa complessità in 7 Macro-Aree Tematiche costruite sulla logica d'uso dell'imprenditore e
        del decisore pubblico — non sul linguaggio burocratico dei decreti ministeriali.
        Ogni area integra bandi europei diretti (Commissione UE), strumenti nazionali (MIMIT, Invitalia, MISE,
        INAIL) e misure regionali (PR FESR/FSE+), coprendo l'intero spettro di beneficiari: PMI, grandi imprese,
        startup innovative, enti pubblici, università e centri di ricerca.
      </div>

      <h4 class="font-semibold text-font24px text-[#364349] mt-10 mb-4">
        La transizione verde come vettore di competitività e accesso al credito
      </h4>

      <div class="flex flex-col md:flex-row items-start gap-8 mt-6">
        <div class="md:w-2/3">
          <p class="mt-0 text-font24px line-height text-justify">
            Il Green Deal europeo ha ridefinito le regole del gioco per imprese
            e territori: la <strong>riduzione delle emissioni e l'efficienza energetica non sono più
              solo obiettivi normativi, ma condizioni di accesso ai finanziamenti
              pubblici e ai mercati bancari.</strong>
          </p>

          <p class="mt-4 text-font24px line-height text-justify">
            Le misure di questa area intercettano imprese manifatturiere che
            investono in decarbonizzazione, Pubbliche Amministrazioni impegnate nella
            riqualificazione urbana e del patrimonio edilizio, e operatori che sviluppano
            modelli di autoconsumo collettivo attraverso le Comunità Energetiche Rinnovabili.
          </p>

          <p class="mt-4 text-font24px line-height text-justify">
            Il comune denominatore è la misurabilità del miglioramento ambientale:
            ogni strumento richiede una rendicontazione quantitativa del risparmio energetico
            o della riduzione delle emissioni, rendendo <strong> la gestione dei dati ESG un fattore
              abilitante</strong> per l'accesso alle risorse.
          </p>
        </div>

        <div class="md:w-1/3">
          <img src="assets/TRANSIZIONE_ECOLOGICA.jpg" alt="Transizione Ecologica"
            class="w-full max-h-[300px] object-cover rounded-[20px] shadow-lg">
        </div>
      </div>

      <h4 class="font-semibold text-font24px text-[#364349] mt-12 mb-4">
        Principali strumenti di finanziamento
      </h4>

      <div class="grid md:grid-cols-2 gap-6 mt-6">
        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Transizione 5.0 — componente green</h5>
          <p class="text-font24px text-gray-700 mb-2 text-justify">
            Credito d'imposta per investimenti che determinano una riduzione certificata
            dei consumi energetici. Il beneficio si scala in funzione dell'intensità del risparmio:
            dal 35% fino al 45% per riduzioni oltre il 10% dei consumi del processo produttivo.
          </p>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Comunità Energetiche Rinnovabili (CER)</h5>
          <p class="text-font24px text-gray-700 mb-2 text-justify">
            Incentivi per la costituzione e gestione di CER, con tariffa incentivante
            sull'energia condivisa e contributi in conto capitale fino al <strong>40%
              dell'investimento</strong> per Comuni sotto 5.000 abitanti.
          </p>
        </div>
      </div>

      <div class="grid md:grid-cols-3 gap-6 mt-6">
        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Conto Termico 2.0</h5>
          <p class="text-font24px text-gray-700 text-justify">
            Incentivi per interventi di efficienza energetica su edifici pubblici
            e impianti industriali. Rimborso fino al <strong>65% delle spese ammissibili</strong>.
          </p>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Programma LIFE (2021-2027)</h5>
          <p class="text-font24px text-gray-700 text-justify">
            Fondo europeo diretto per progetti di innovazione ambientale e adattamento climatico.
            Budget complessivo: <strong>5,4 miliardi di euro</strong>.
          </p>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Bandi MASE</h5>
          <p class="text-font24px text-gray-700 text-justify">
            Misure nazionali per economia circolare, gestione dei rifiuti e mobilità sostenibile.
          </p>
        </div>
      </div>

      <h4 class="font-semibold text-font24px text-[#364349] mt-12 mb-4">
        Dotazioni finanziarie di riferimento
      </h4>

      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <div class="bg-emerald-50 border-l-4 border-emerald-500 p-4">
          <h5 class="font-semibold text-emerald-800 text-sm">Transizione 5.0</h5>
          <p class="text-xs text-emerald-700 mt-1">Plafond complessivo di <strong>6,3 miliardi</strong> (PNRR)</p>
        </div>
        <div class="bg-green-50 border-l-4 border-green-500 p-4">
          <h5 class="font-semibold text-green-800 text-sm">CER</h5>
          <p class="text-xs text-green-700 mt-1"><strong>2,2 miliardi di euro</strong> (PNRR)</p>
        </div>
        <div class="bg-lime-50 border-l-4 border-lime-500 p-4">
          <h5 class="font-semibold text-lime-800 text-sm">Conto Termico 2.0</h5>
          <p class="text-xs text-lime-700 mt-1"><strong>~900 milioni/anno</strong></p>
        </div>
        <div class="bg-teal-50 border-l-4 border-teal-500 p-4">
          <h5 class="font-semibold text-teal-800 text-sm">Programma LIFE</h5>
          <p class="text-xs text-teal-700 mt-1"><strong>5,4 miliardi</strong> (UE)</p>
        </div>
      </div>

      <div
        class="mt-12 p-6 bg-gradient-to-r from-emerald-50 via-green-50 to-teal-50 rounded-xl border-l-4 border-emerald-500">
        <p class="text-font24px font-medium text-[#364349] mb-3 text-justify">
          <strong>Vuoi ridurre i costi energetici o costituire una Comunità Energetica?</strong>
        </p>
        <p class="text-font24px text-gray-700 text-justify">
          Cerca i bandi green attivi per la tua Regione e dimensione aziendale.
        </p>
        <div (click)="goTo('cerca-bando')"
          class="mt-8 text-white cursor-pointer bg-quintary ml-auto w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
          Ricerca bandi
        </div>
      </div>

    </div>
  </div>
</div>